import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"

//import Table from "../../../components/Table"
//import TableGrid from "../../../components/TableReactGrid"
import Table from "../../../components/Table"


import {
    schedule_get_rows_table,
    schedule_set_valores_lote,
    schedule_get_rows_table_count,
    schedule_set_valores_unitario
} from "../../../store/actions/schedule";

import {
    DataTableSkeleton,
    TextArea,
    Grid,
    Modal,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
} from "carbon-components-react";


import leng from "../../../data";

import moment from "moment";
import {Chat20, Document20, Download20, ResetAlt20, Warning16, WarningAlt20} from "@carbon/icons-react";
import TableGrid from "../../../components/TableReactGrid";


const headers = [
    {name: "no-currents", title: <strong>No-currents Assets</strong>},
    {name: "may20", title: <strong>May 20</strong>},
    {name: "jun20", title: <strong>Jun 20</strong>},
    {name: "dif_money", title: <strong>Dif. $</strong>},
    {name: "dif_porcent", title: <strong>Dif. %</strong>},
    {name: "comments", title: <strong>Comments</strong>},
    {name: "files", title: <strong>Files</strong>},

];
const rowsTable = [
    {
        "no-currents": "Goodwill at cost",
        "may20": "396.176",
        "jun20": "394.760",
        "dif_money": "0",
        "dif_porcent": <WarningAlt20/>,
        "comments": <Chat20/>,
        "files": <Document20/>,
        "items": null
    }, {
        "no-currents": "Goodwill accumulated impairment",
        "may20": "396.176",
        "jun20": "394.760",
        "dif_money": "0",
        "dif_porcent": "0.0%",
        "comments": <Chat20/>,
        "files": <Document20/>,
        "items": null
    },
    {
        "no-currents": "Indefinite lived intangibles",
        "may20": "396.176",
        "jun20": "394.760",
        "dif_money": "0",
        "dif_porcent": "-8,8%",
        "comments": <Chat20/>,
        "files": <Document20/>,
        "items": [{
            "no-currents": "FINITE LIVED TRADEMARK AT COST",
            "may20": "396.176",
            "jun20": "394.760",
            "dif_money": "0",
            "dif_porcent": "-8,8%",
            "comments": <Chat20/>,
            "files": <Document20/>,
            "items": null
            /*"items": [{"may20": "Male", "no-currents": "David", "jun20": "Chicago", "car": "Toyota Corolla"}, {
                "may20": "Male",
                "no-currents": "William",
                "jun20": "Chicago",
                "car": "Audi A4"
            }, {"may20": "Male", "no-currents": "Paul", "jun20": "Paris", "car": "Chevrolet Cruze"}, {
                "may20": "Female",
                "no-currents": "Barbara",
                "jun20": "Los Angeles",
                "car": "Toyota Corolla"
            }]*/
        }, {
            "no-currents": "FINITE LIVED TECHNOLOGY AT COST",
            "may20": "396.176",
            "jun20": "394.760",
            "dif_money": "0",
            "dif_porcent": "-8,8%",
            "comments": <Chat20/>,
            "files": <Document20/>,
            "items": null
            /*"items": [{"may20": "Male", "no-currents": "David", "jun20": "Chicago", "car": "Toyota Corolla"}, {
                "may20": "Male",
                "no-currents": "William",
                "jun20": "Chicago",
                "car": "Audi A4"
            }, {"may20": "Male", "no-currents": "Paul", "jun20": "Paris", "car": "Chevrolet Cruze"}, {
                "may20": "Female",
                "no-currents": "Barbara",
                "jun20": "Los Angeles",
                "car": "Toyota Corolla"
            }]*/
        },
            {
                "no-currents": "FINITE LIVED OTHER INTANGIBLES AT COST",
                "may20": "396.176",
                "jun20": "394.760",
                "dif_money": "0",
                "dif_porcent": "-8,8%",
                "comments": <Chat20/>,
                "files": <Document20/>,
                "items": null
                /*"items": [{"may20": "Male", "no-currents": "David", "jun20": "Chicago", "car": "Toyota Corolla"}, {
                    "may20": "Male",
                    "no-currents": "William",
                    "jun20": "Chicago",
                    "car": "Audi A4"
                }, {"may20": "Male", "no-currents": "Paul", "jun20": "Paris", "car": "Chevrolet Cruze"}, {
                    "may20": "Female",
                    "no-currents": "Barbara",
                    "jun20": "Los Angeles",
                    "car": "Toyota Corolla"
                }]*/
            },
            {
                "no-currents": "FINITE LIVED TECHNOLOGY ACCUMULATED A...",
                "may20": "396.176",
                "jun20": "394.760",
                "dif_money": "0",
                "dif_porcent": "-8,8%",
                "comments": <Chat20/>,
                "files": <Document20/>,
                "items": null
                /*"items": [{"may20": "Male", "no-currents": "David", "jun20": "Chicago", "car": "Toyota Corolla"}, {
                    "may20": "Male",
                    "no-currents": "William",
                    "jun20": "Chicago",
                    "car": "Audi A4"
                }, {"may20": "Male", "no-currents": "Paul", "jun20": "Paris", "car": "Chevrolet Cruze"}, {
                    "may20": "Female",
                    "no-currents": "Barbara",
                    "jun20": "Los Angeles",
                    "car": "Toyota Corolla"
                }]*/
            }, {
                "no-currents": "FIT LIV OTR INA ACM AMO",
                "may20": "396.176",
                "jun20": "394.760",
                "dif_money": "0",
                "dif_porcent": "-8,8%",
                "comments": <Chat20/>,
                "files": <Document20/>,
                "items": null
                /*"items": [{"may20": "Male", "no-currents": "David", "jun20": "Chicago", "car": "Toyota Corolla"}, {
                    "may20": "Male",
                    "no-currents": "William",
                    "jun20": "Chicago",
                    "car": "Audi A4"
                }, {"may20": "Male", "no-currents": "Paul", "jun20": "Paris", "car": "Chevrolet Cruze"}, {
                    "may20": "Female",
                    "no-currents": "Barbara",
                    "jun20": "Los Angeles",
                    "car": "Toyota Corolla"
                }]*/
            }]
    }, {
        "no-currents": "Software",
        "may20": "396.176",
        "jun20": "394.760",
        "dif_money": "0",
        "dif_porcent": <WarningAlt20/>,
        "comments": <Chat20/>,
        "files": <Document20/>, "items": null
    }, {
        "no-currents": "Property, plant and equipment",
        "may20": "396.176",
        "jun20": "394.760",
        "dif_money": "0",
        "dif_porcent": <WarningAlt20/>,
        "comments": <Chat20/>,
        "files": <Document20/>, "items": null
    }
];
const tableColumnExtensions = [
    {columnName: 'files', width: 150, align: "center"},
    {columnName: 'comments', width: 150, align: "center"},
    {columnName: 'dif_porcent', width: 100, align: "center"},
    {columnName: 'dif_money', width: 100, align: "center"},
    {columnName: 'may20', width: 200},
    {columnName: 'jun20', width: 200},
    {columnName: 'no-currents', width: 800},
];


class Edit extends Component {

    async componentDidMount() {
        //await this.props.fetchData(0);
        //await this.props.countRows();
    }

    async onSubmitForm(type, data) {
        if (type == "Individual") {
            this.props.saveUnitario(data);
        } else {
            this.props.saveLote(data);
        }
    }


    render() {
        const isLoading = false;

        const rowsComment = [
            {
                id: 'load-balancer-1',
                name: 'Load Balancer 1',
                rule: 'Round robin',
                Status: 'Starting',
            },
            {
                id: 'load-balancer-2',
                name: 'Load Balancer 2',
                rule: 'DNS delegation',
                status: 'Active',
            },
            {
                id: 'load-balancer-3',
                name: 'Load Balancer 3',
                rule: 'Round robin',
                status: 'Disabled',
            },
        ];
        const headersComments = ['Name', 'Rule', 'Status'];
        return (
            <Layout>
                <Grid class="painel" fullWidth>
                    <div className="container-fluid">
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>{leng.sideBar.intelligentJourney.links[5]}</h3>
                        </div>



                        {isLoading ? (
                                <DataTableSkeleton/>
                            ) :

                            (
                                <>
                                    <div className="MuiPaper-root div-header-border"
                                         style={{minHeight: "100px", backgroundColor: "#FFF", marginTop: "50px"}}>
                                        <div style={{
                                            paddingTop: "16px",
                                            paddingLeft: "26px",
                                            fontSize: "20px",
                                            color: "#161616"
                                        }}>UniBusinessUnit / Balance Sheet / No-current Assets / All categories (18)
                                            / All subcategories (146)
                                        </div>
                                        <div style={{
                                            paddingLeft: "26px",
                                            fontSize: "12px",
                                            paddingBottom: "16px",
                                            paddingTop: "8px",
                                            color: "#161616"
                                        }}>May 2020 / Jun 2020
                                        </div>
                                        <div className="col-12 row flex-row-reverse"
                                             style={{paddingTop: "30px", paddingBottom: "10px"}}>
                                            <div style={{width: "40px", textAlign: "center"}}>
                                                <a
                                                    href="https://domrock365-my.sharepoint.com/:w:/g/personal/jefferson_domrock_ai/Efmka4P0z0VHngPPHtp6sqYBa3iDnyniE_h5TKpHCHFNEA?e=klOzNf"
                                                    target="_blank"><ResetAlt20/></a>
                                            </div>
                                            <div style={{width: "40px", textAlign: "center"}}>
                                                <a
                                                    href="https://domrock365-my.sharepoint.com/:x:/g/personal/jefferson_domrock_ai/EX3jbf11MdFAsGpI-qQS_pUBu8bYtltCfKoAdkq8fx9Vbg?e=Xe0cHw"
                                                    target="_blank"><Download20/></a>
                                            </div>
                                            <div style={{width: "40px", textAlign: "center"}}>
                                                <a
                                                    href="https://domrock365-my.sharepoint.com/:x:/g/personal/jefferson_domrock_ai/EX3jbf11MdFAsGpI-qQS_pUBu8bYtltCfKoAdkq8fx9Vbg?e=Xe0cHw"
                                                    target="_blank"><Chat20/></a>
                                            </div>
                                        </div>
                                    </div>
                                    <TableGrid rows={rowsTable} headers={headers}
                                               tableColumnExtensions={tableColumnExtensions}/>
                                </>
                            )}
                    </div>
                </Grid>
            </Layout>
        )
    }
}

const mapStateToProps = ({schedule}) => schedule;

const mapDispatchToProps = dispatch => ({
    saveLote: (valor) => dispatch(schedule_set_valores_lote(valor)),
    saveUnitario: (valor) => dispatch(schedule_set_valores_unitario(valor)),
    fetchData: (skip) => dispatch(schedule_get_rows_table(skip)),
    countRows: () => dispatch(schedule_get_rows_table_count()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Edit);
